import { Package } from 'lucide-react';
import { SECTION_CONFIGS } from '../../constants/sectionConfig.constants';
import type { Application } from '../../types/application.types';
import { CollapsibleSection } from '../shared/CollapsibleSection';

interface OptionsServicesStepProps {
  application: Application;
}

export function OptionsServicesStep({ application }: OptionsServicesStepProps) {
  const equipmentConfig = SECTION_CONFIGS.options;
  const hasEquipment = application.resolvedEquipments && application.resolvedEquipments.length > 0;
  const hasServices = application.specificDetails && Object.keys(application.specificDetails).length > 0;

  // Si aucune option ni service
  if (!hasEquipment && !hasServices) {
    return (
      <div className="space-y-4">
        <div className="bg-slate-50 border border-slate-200 rounded-xl p-6 text-center">
          <Package className="w-12 h-12 text-slate-300 mx-auto mb-3" />
          <p className="text-slate-500 text-sm">Aucun équipement ou service supplémentaire demandé</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* Équipements et Services */}
      {hasEquipment && (
        <CollapsibleSection
          title="Équipements et Services"
          color={equipmentConfig.color}
          icon={equipmentConfig.icon}
          defaultOpen={true}
        >
          <div className="space-y-3">
            {application.resolvedEquipments!.map((equipment) => (
              <div key={equipment.id} className="px-4 py-3 bg-amber-50 rounded-lg border border-amber-200">
                <div className="font-medium text-amber-900">{equipment.name}</div>
                {equipment.description && <div className="text-sm text-amber-700 mt-1">{equipment.description}</div>}
              </div>
            ))}
          </div>
        </CollapsibleSection>
      )}
    </div>
  );
}
